import axios from "axios";
import { API } from "./api";

// Fire-and-forget analytics event. Must never block or break the UX.
export const trackEvent = (event, page = "home") => {
  axios.post(`${API}/track`, { event, page }).catch(() => {});
};

// Public site config (e.g. scheduling/calendar embed URL).
export const getPublicConfig = () =>
  axios
    .get(`${API}/config/public`)
    .then((r) => r.data)
    .catch(() => ({ scheduling_link: "" }));
